// extracted by mini-css-extract-plugin
module.exports = {"root":"Event_root__InQqW","page":"Event_page__AHUfH"};